
<template>
  <!-- 日志面板 -->
  <div :class="['app-container', { 'bdc-log-page': isBdc }]">
    <div class="chart-container">
      <div style="width:100%;float:left">
        <el-button type="primary" size="mini" @click="btntext1" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">查询所有(默认)</el-button>
        <el-button type="primary" size="mini" @click="btntext2" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">条件查询</el-button>
        <el-button type="primary" size="mini" @click="btntext3" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">排序查询</el-button>
        <el-button type="primary" size="mini" @click="btntext4" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">时间条件查询</el-button>
        <el-button type="primary" size="mini" @click="btntext5" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">计数查询</el-button>
        <el-button type="primary" size="mini" @click="btntext6" style="width:120px;margin-left:15px;float:left;margin-top:10px;margin-bottom:10px">分组过滤查询</el-button>
      </div>

      <div style="width:100%;float:left">

        <div style="width:100%;float:left;margin-left:15px;font-size:12px;color:#ff0000">
          select后面支持的字段： 客户端
          <el-popover placement="top-start" width="260" trigger="hover">
            <span class="zhibiaoshuoming">
              <span class="zhibiaoshuoming_title">客户端支持字段</span>
              <p v-html="kehuduanshuoming"></p>
            </span>
            <svg-icon slot="reference" icon-class="ask" class="icon" />
          </el-popover>； 服务端 <el-popover placement="top-start" width="260" trigger="hover">
            <span class="zhibiaoshuoming">
              <span class="zhibiaoshuoming_title">服务端支持字段</span>
              <p v-html="fuwuduanshuoming"></p>
            </span>
            <svg-icon slot="reference" icon-class="ask" class="icon" />
          </el-popover>
        </div>
        <el-input size="mini" style="width:796px;float:left;margin-top:10px;margin-bottom:10px" type="textarea" v-model="querydata.sqlCode"></el-input>
        <el-button type="primary" size="mini" @click="mohuchaxun" style="margin-left:15px;float:left;margin-top:10px;margin-bottom:10px" :loading="modelloading">查询</el-button>
      </div>

      <div style="width:100%;float:left">
        <el-select v-model="querydata.platformType" size="mini" @change="platformTypechange" placeholder="" style="width:200px;float:left;margin-left:15px;margin-bottom:10px">
          <el-option label="服务端" value="1"></el-option>
          <el-option label="客户端" value="2"></el-option>
        </el-select>
        <el-input size="mini" style="width:200px;float:left;margin-left:15px;margin-bottom:10px" v-model="mohusousuoname" @input="mohusousuonameinput" placeholder="模糊搜索"></el-input>
        <div v-if="isBdc" class="bdc-log-alert">
          <svg-icon icon-class="bdc-icon-attention" class="bdc-log-alert__icon" />
          <span class="bdc-log-alert__text">仅支持7日内查询</span>
        </div>
        <el-tag v-else type="danger" style="margin-left:15px">仅支持7日内查询</el-tag>
        <div v-if="!isBdc" style="float:right;margin-right:10px;cursor: pointer;margin-left:10px" title="下载">
          <el-button slot="reference" size="mini" icon="el-icon-download" :class="{ 'bdc-log-download': isBdc }" style="font-size: 16px;padding:5px 15px;" @click="exportExcel($event,'xiazaizhucequdaoliebiao')"></el-button>
        </div>
      </div>

      <div class="bdc-log-table-section" v-loading="modelloading">

        <el-table ref="logTable" :header-cell-style="isBdc ? undefined : {background:'#eef1f6',color:'#606266',fontSize:'12px',padding:'8px 6px !important'}" :data="tableData3.slice((currentPage3-1)*sizePage3,currentPage3*sizePage3)" :class="isBdc ? 'grayTableTile bdc-crosshair-table' : 'tb-edit tb-edit1'" style="width: 100%" border @cell-mouse-enter="handleCellMouseEnter" @cell-mouse-leave="handleCellMouseLeave">
          <el-table-column prop="time" label="时间" width="150">
          </el-table-column>
          <el-table-column prop="eventName" label="名称" width="200">
          </el-table-column>
          <el-table-column prop="content" label="日志内容">
            <template slot-scope="scope">
              <div v-if="isBdc" class="bdc-log-content-cell">
                <div class="bdc-log-content-cell__box" :class="{ 'is-open': scope.row.open }" v-html="scope.row[scope.column.property]" />
                <button type="button" class="bdc-log-content-cell__toggle" @click="scope.row.open = !scope.row.open">
                  <span>{{ scope.row.open ? '收起' : '展开' }}</span>
                  <img class="bdc-log-content-cell__arrow" :class="{ 'is-open': scope.row.open }" :src="logExpandIcon" alt="">
                </button>
              </div>
              <template v-else>
                <div :style="{height : scope.row.open ? 'auto': '36px'}" style="border:1px solid #dedede;border-radius: 6px;padding:5px 50px 5px 5px;overflow:hidden" v-html="scope.row[scope.column.property]"></div>
                <el-button size="mini" style="padding:0px;position:absolute;top:20px;right:14px" type="text" @click="scope.row.open = !scope.row.open">{{scope.row.open ? '↑ 收起' : '↓ 展开'}}</el-button>
              </template>
            </template>
          </el-table-column>
        </el-table>

        <div :class="['bdc-log-table-pagination', { 'bdc-table-footer': isBdc }]">
          <div v-if="isBdc" class="bdc-table-footer__actions">
            <bdc-download-button size="mini" @click="exportExcel($event,'xiazaizhucequdaoliebiao')" />
          </div>
          <div :class="isBdc ? 'bdc-table-footer__pagination' : ''">
          <pagination v-show="dataLength3 > 0" :auto-scroll="false" :background="!isBdc" :total="dataLength3" :page.sync="currentPage3" :limit.sync="sizePage3" :page-sizes="[10, 15, 20, 30, 50]" :class="isBdc ? 'bdc-table-pagination' : ''" />
          </div>
        </div>

        <el-table id="xiazaizhucequdaoliebiao" style="display: none;" :data="tableData3" class="tb-edit tb-edit1">
          <el-table-column prop="time" label="时间">
          </el-table-column>
          <el-table-column prop="eventName" label="名称">
          </el-table-column>
          <el-table-column prop="content" label="日志内容">
            <template slot-scope="scope">
              <div v-html="scope.row[scope.column.property]"></div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import BdcDownloadButton from '@/components/BdcTableFooter/BdcDownloadButton'
import { logViewsqlQuery } from "@Bdc~/api/ajax_model";

import FileSaver from "file-saver";
import XLSX from "xlsx";

export default {
  name: "metaevent",
  components: { Pagination, BdcDownloadButton },
  data() {
    return {
      modelloading: true,
      kehuduanshuoming:
        "<p>appkey,device_id,event_time2,buess_time<br>client_os,server_id,role_id,user_id<br>role_key,user_ip,channel_name,channel_id<br>app_channel_id,session_id,event_id<br>event_name,guide_id,guide_num</p>",
      fuwuduanshuoming:
        "<p>appkey,platform,event_id,client_os<br>server_id,channel_id,app_channel_id<br>device_id,user_id,open_id,role_id<br>role_key,user_ip,buess_time<br>amount,unit,role_num,money_type<br>reason_id,shop_type,product_id<br>product_type,role_level,vip_level<br>role_name,order_id,game_order_id<br>pay_time,get_time,total_charge<br>extra_get1,extra_get2,money_type<br>before_balance,after_balance<br>reason_info</p>",
      mohusousuoname: "",
      querydata: {
        platformType: "1",
        sqlCode: ""
      },

      tableData3: [],
      tableData3copy: [],
      currentPage3: 1,
      dataLength3: 0,
      sizePage3: 10
    };
  },
  computed: {
    isBdc() {
      return process.env.VUE_APP_PROJECT_TYPE === 'bdc'
    },
    logExpandIcon() {
      return require('@Sys~/assets/bdc-log/btn-arrow-single.svg')
    }
  },
  created() {
    this.logViewsqlQuery();
  },
  mounted() { },
  methods: {
    clearTableCrosshair() {
      const table = this.$refs.logTable
      if (!table || !table.$el) return
      table.$el.querySelectorAll('.bdc-table-crosshair-row, .bdc-table-crosshair-col, .bdc-table-crosshair-active')
        .forEach(el => el.classList.remove('bdc-table-crosshair-row', 'bdc-table-crosshair-col', 'bdc-table-crosshair-active'))
    },

    handleCellMouseEnter(row, column, cell) {
      if (!this.isBdc || !cell || !column) return
      this.clearTableCrosshair()

      const root = this.$refs.logTable.$el
      const rowEl = cell.parentElement
      if (!rowEl || rowEl.tagName !== 'TR') return

      const rowIndex = Array.from(rowEl.parentElement.children).indexOf(rowEl)
      root.querySelectorAll('tbody').forEach(tbody => {
        const tr = tbody.children[rowIndex]
        if (tr) {
          Array.from(tr.children).forEach(td => td.classList.add('bdc-table-crosshair-row'))
        }
      })

      if (column.id) {
        root.querySelectorAll(`td.${column.id}, th.${column.id}`).forEach(el => {
          el.classList.add('bdc-table-crosshair-col')
        })
      }

      cell.classList.add('bdc-table-crosshair-active')
    },

    handleCellMouseLeave(row, column, cell, event) {
      if (!this.isBdc) return
      const root = this.$refs.logTable && this.$refs.logTable.$el
      if (root && event.relatedTarget && root.contains(event.relatedTarget)) return
      this.clearTableCrosshair()
    },

    logViewsqlQuery() {
      this.modelloading = true;
      console.log(this.querydata);
      logViewsqlQuery(this.querydata).then(response => {
        this.modelloading = false;
        console.log(response);
        if (response.code == 1) {
          for (var i = 0; i < response.data.length; i++) {
            response.data[i].open = false;
          }
          this.tableData3 = response.data;
          this.tableData3copy = JSON.parse(JSON.stringify(response.data));
          this.dataLength3 = response.data.length;
        }
      });
    },
    mohuchaxun() {
      this.currentPage3 = 1;
      this.logViewsqlQuery();
    },
    handleSizeChange3(e) {
      // table 分页数量变化
      this.sizePage3 = e;
    },
    handleCurrentChange3(e) {
      // table 分页变化
      this.currentPage3 = e;
    },
    platformTypechange(e) {
      this.querydata.platformType = e;
      this.mohuchaxun();
    },
    btntext1() {
      this.querydata.sqlCode = "";
      this.mohuchaxun();
    },
    btntext2() {
      this.querydata.sqlCode = "select * from log where event_id='10006'";
      this.mohuchaxun();
    },
    btntext3() {
      this.querydata.sqlCode =
        "select * from log where event_id='10006' order by buess_time desc";
      this.mohuchaxun();
    },
    btntext4() {
      this.querydata.sqlCode =
        "select * from log where date_format(from_unixtime(buess_time), '%Y-%m-%d %H:%i:%S')>'2018-09-06 11:19:46'";
      this.mohuchaxun();
    },
    btntext5() {
      this.querydata.sqlCode =
        "select count(distinct role_key) from log where date_format(from_unixtime(buess_time), '%Y-%m-%d %H:%i:%S')>='2018-09-25 00:00:00' and date_format(from_unixtime(buess_time), '%Y-%m-%d %H:%i:%S')<'2018-09-25 11:35:00' and event_id='10005' and platform='SERVER_TEST' and role_key<>'' and role_key is not null";
      this.mohuchaxun();
    },
    btntext6() {
      this.querydata.sqlCode =
        "select count(*) as num from (select device_id,substr(date_format(from_unixtime(min(buess_time)), '%Y-%m-%d %H:%i:%S'),1,10) from log where 1=1 and date_format(from_unixtime(buess_time), '%Y-%m-%d %H:%i:%S')>'2018-09-21 16:20:00' and date_format(from_unixtime(buess_time), '%Y-%m-%d %H:%i:%S')<'2018-09-25 11:00:00'and platform='SERVER_TEST' and device_id<>'' and device_id is not null group by device_id HAVING substr(date_format(from_unixtime(min(buess_time)), '%Y-%m-%d %H:%i:%S'),1,10)='2018-09-25')";
      this.mohuchaxun();
    },
    mohusousuonameinput() {
      var arr = [];
      if (this.mohusousuoname != "") {
        for (var i = 0; i < this.tableData3copy.length; i++) {
          if (
            this.tableData3copy[i].eventName.indexOf(this.mohusousuoname) != -1
          ) {
            arr.push(this.tableData3copy[i]);
          } else if (
            this.tableData3copy[i].time.indexOf(this.mohusousuoname) != -1
          ) {
            arr.push(this.tableData3copy[i]);
          } else if (
            this.tableData3copy[i].content.indexOf(this.mohusousuoname) != -1
          ) {
            arr.push(this.tableData3copy[i]);
          }
        }
        this.tableData3 = arr;
        this.currentPage3 = 1;
        this.dataLength3 = this.tableData3.length;
      } else {
        this.tableData3 = this.tableData3copy;
        this.currentPage3 = 1;
        this.dataLength3 = this.tableData3.length;
      }
    },
    exportExcel(e, id) {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector("#" + id));
      /* get binary string as output */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "日志文件.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.app-container {
  background-color: #364652;
}
.chart-container {
  position: relative;
  // padding: 15px;
  padding-bottom: 1px;
  /* width: 100%;
    height: 30%; */
}
.ibox-title {
  line-height: 32px;
  padding: 4px 15px 3px;
}

/* .grid-content  */
.ibox-title {
  border-bottom: 1px solid #dedede;
}
.ibox-content {
  border: none;
}
.ibox-title h5 {
  margin: 0;
}
.tb-edit {
  width: 98%;
  margin-left: 1%;
  margin-top: 15px;
  font-size: 12px !important;
}
/* .el-table th{background:#fff;} */
</style>

<style>
.el-dialog__body {
  padding: 10px 5px;
}
.el-tabs__header {
  margin-bottom: 0px;
}
.el-tabs__nav {
  /* margin-left: 30px;
  margin-right: 30px; */
}
.el-row {
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #fff;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 30px;
  /* padding-bottom: 15px; */
}
.row-bg {
  /* padding: 10px 0; */
  background-color: #f9fafc;
}
.tb-edit1 tr td .cell {
  padding: 0px 10px !important;
}

.el-table th {
  background-color: #fff;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.panel-group {
  // margin-top: 18px;
  .card-panel-col {
    // margin-bottom: 32px;
  }
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.1);
    border-color: rgba(0, 0, 0, 0.05);
    &:hover {
      .card-panel-icon-wrapper {
        color: #fff;
      }
      .icon-people {
        background: #40c9c6;
      }
      .icon-message {
        background: #36a3f7;
      }
      .icon-money {
        background: #f4516c;
      }
      .icon-shoppingCard {
        background: #34bfa3;
      }
    }
    .icon-people {
      color: #40c9c6;
    }
    .icon-message {
      color: #36a3f7;
    }
    .icon-money {
      color: #f4516c;
    }
    .icon-shoppingCard {
      color: #34bfa3;
    }
    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 14px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }
    .card-panel-icon {
      float: left;
      font-size: 48px;
    }
    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 26px;
      margin-left: 0px;
      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
      }
      .card-panel-num {
        font-size: 20px;
      }
    }
  }
}
</style>

<style>
.aaa {
  text-align: center;
}
.shishitophuizong {
  width: 16.6%;
  float: left;
  text-align: center;
}
.shishitophuizong1 {
  font-size: 14px;
  font-weight: 600;
  padding: 5px 0px;
}
.shishitophuizong2 {
  font-size: 30px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong3 {
  font-size: 12px;
  font-weight: 100;
  padding: 5px 0px;
}
.shishitophuizong1 icon {
  width: 15px;
  height: 15px;
}

.shishitophuizonger {
  width: 16.6%;
  float: left;
  text-align: center;
  border-top: 1px solid #e7eaec;
  padding: 8px 0px;
  vertical-align: middle;
  color: #337ab7;
  font-size: 14px;
}
body:not(.bdc-app-body) .el-tag {
  background: none;
  border: none;
}

.zhibiaoshuoming {
  font-size: 12px;
  color: #999;
}
.zhibiaoshuoming_title {
  font-size: 14px;
  color: #666;
  display: block;
  border-bottom: 1px solid #dedede;
  padding-bottom: 10px;
}
.el-loading-mask {
  z-index: 5;
}
.disqudao {
  display: none;
}

.tianjiastyle,
.tianjiastyle1 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 10;
}
.tianjiastyle_bg,
.tianjiastyle_bg1 {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
}
.tianjiastyle_content {
  width: 720px;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 50%;
  margin-left: -350px;
  border: 1px solid #dedede;
}
.tianjiastyle_content1 {
  width: 90%;
  background: #fff;
  padding: 20px;
  position: absolute;
  top: 50px;
  left: 5%;
  border: 1px solid #dedede;
}
.wubaobiao {
  width: 300px;
  height: 200px;
  text-align: center;
  background: #fff;
  margin-bottom: 600px;
  color: #1890ff;
  position: relative;
  left: 50%;
  margin-left: -150px;
  top: 150px;
}
</style>